module.exports = __webpack_public_path__ + "static/img/welfare4.67d050ac.jpg";